'use client';

import { useState, memo } from 'react';
import styles from './PricingFactorCard.module.css';

interface PricingFactorCardProps {
  factor: {
    title: string;
    description: string;
  };
  index: number;
}

export const PricingFactorCard = memo(function PricingFactorCard({ factor, index }: PricingFactorCardProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={styles.card}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Gradient accent top line */}
      <div className={styles.accentLine} />
      
      <h3 className={styles.title}>
        {factor.title}
      </h3>
      <p className={styles.description}>
        {factor.description}
      </p>
    </div>
  );
});
